import { DefaultTitle, useTitle as useTitleVisibleUi } from "visible-ui";

function useTitle(title: string) {
  useTitleVisibleUi(title, DefaultTitle.CyberSurveys);
}

export default useTitle;
